(() => {
  const selector = '[data-floating-cart]';
  const countSelector = '[data-floating-cart-count]';
  let refreshTimer;

  const normalizeCount = (value) => {
    const count = Number(value);
    return Number.isFinite(count) && count > 0 ? count : 0;
  };

  const updateRoot = (root, itemCount) => {
    const countNode = root.querySelector(countSelector);
    if (!countNode) return;

    const count = normalizeCount(itemCount);
    countNode.textContent = count;
    countNode.toggleAttribute('hidden', count === 0);
  };

  const refresh = () => {
    document.querySelectorAll(selector).forEach((root) => {
      const cartUrl = root.dataset.cartUrl || (window.routes && window.routes.cart) || '/cart';

      fetch(`${cartUrl}.js`, { credentials: 'same-origin' })
        .then((response) => response.json())
        .then((cart) => updateRoot(root, cart.item_count))
        .catch((error) => console.error(error));
    });
  };

  const scheduleRefresh = () => {
    if (refreshTimer) return;

    refreshTimer = window.setTimeout(() => {
      refreshTimer = null;
      refresh();
    }, 80);
  };

  ['cartChange', 'updateCart'].forEach((eventName) => {
    document.addEventListener(eventName, scheduleRefresh, false);
    window.addEventListener(eventName, scheduleRefresh, false);
  });
})();